export default "__VITE_ASSET__55QA3lZy__"